module.exports = __webpack_public_path__ + "static/media/arrow-top.a7a5d701.svg";